import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ChatWidget from "@/components/ChatWidget";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import BrowseHunts from "@/pages/BrowseHunts";
import FindYourHunt from "@/pages/FindYourHunt";
import About from "@/pages/About";
import Process from "@/pages/Process";
import DispatchCircle from "@/pages/DispatchCircle";
import Gallery from "@/pages/Gallery";
import Journal from "@/pages/Journal";
import Outfitters from "@/pages/Outfitters";
import ExpeditionDetail from "@/pages/ExpeditionDetail";
import DestinationDetail from "@/pages/DestinationDetail";
import OutfitterDetail from "@/pages/OutfitterDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CircleDashboard from "@/pages/CircleDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import DepositPayment from "@/pages/DepositPayment";
import PaymentSuccess from "@/pages/PaymentSuccess";
import { useEffect } from "react";

function Stub({ title }) {
  return (
    <div className="min-h-screen bg-bone pt-28 pb-20">
      <div className="container-dh text-center">
        <p className="text-label text-brass mb-3">Coming Soon</p>
        <h1 className="font-display text-4xl font-bold text-carbon">{title}</h1>
      </div>
    </div>
  );
}

function GA4Tracker() {
  useEffect(() => {
    const gaId = process.env.REACT_APP_GA4_ID;
    if (!gaId || gaId === "G-XXXXXXXXXX") return;
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    script.async = true;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", gaId);
  }, []);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <GA4Tracker />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/expeditions" element={<BrowseHunts />} />
              <Route path="/expeditions/:slug" element={<ExpeditionDetail />} />
              <Route path="/destinations/:code" element={<DestinationDetail />} />
              <Route path="/outfitters" element={<Outfitters />} />
              <Route path="/outfitters/:slug" element={<OutfitterDetail />} />
              <Route path="/apply" element={<FindYourHunt />} />
              <Route path="/about" element={<About />} />
              <Route path="/process" element={<Process />} />
              <Route path="/dispatch-circle" element={<DispatchCircle />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/deposit" element={<DepositPayment />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/circle/dashboard" element={
                <ProtectedRoute requireCircle>
                  <CircleDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/privacy" element={<Stub title="Privacy Policy" />} />
              <Route path="/terms" element={<Stub title="Terms of Service" />} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
